import { getCurrentInstance } from 'vue';
import Main from "@/views/Main.vue";

const customerRoutes = [
  {
    path: "/sizeAccess",
    icon: "android-menu",
    name: "sizeAccess",
    title: "尺码管理",
    component: Main,
    children: [
      {
        path: "vendorList",
        title: "买手店清洗规则管理",
        name: "sizeAccessVendorList",
        component: resolve => {
          require(["@/views/size/vendorList.vue"], resolve);
        }
      },
      {
        path: "vendorRules/:id",
        title: "买手店清洗规则列表",
        name: "sizeAccessVendorRules",
        parent: [
          {
            path: "/sizeAccess",
            name: "sizeAccess",
            title: "尺码管理",
          },
          {
            path: "/sizeAccess/vendorList",
            title: "买手店清洗规则管理",
            name: "sizeAccessVendorList",
          }
        ],
        component: resolve => {
          require(["@/views/size/vendorRules.vue"], resolve);
        }
      },
      {
        path: "rule/vendor/create/:vendorId",
        title: "买手店清洗规则列表",
        name: "sizeAccessVendorRuleFormCreate",
        parent: [
          {
            path: "/sizeAccess",
            name: "sizeAccess",
            title: "尺码管理",
          },
          {
            path: "/sizeAccess/vendorList",
            title: "买手店清洗规则管理",
            name: "sizeAccessVendorList",
          },
          {
            path: () => {
              return `/sizeAccess/vendorRules/${getCurrentInstance().proxy.$route.params.vendorId}`;
            },
            title: "买手店清洗规则列表",
            name: "sizeAccessVendorRules",
          }
        ],
        component: resolve => {
          require(["@/views/size/ruleForm.vue"], resolve);
        }
      },
      {
        path: "rule/vendor/edit/:vendorId/:id",
        title: "买手店清洗规则列表",
        name: "sizeAccessVendorRuleFormCreate",
        parent: [
          {
            path: "/sizeAccess",
            name: "sizeAccess",
            title: "尺码管理",
          },
          {
            path: "/sizeAccess/vendorList",
            title: "买手店清洗规则管理",
            name: "sizeAccessVendorList",
          },
          {
            path: () => {
              return `/sizeAccess/vendorRules/${getCurrentInstance().proxy.$route.params.vendorId}`;
            },
            title: "买手店清洗规则列表",
            name: "sizeAccessVendorRules",
          }
        ],
        component: resolve => {
          require(["@/views/size/ruleForm.vue"], resolve);
        }
      },
      {
        path: "rule/platform/create",
        title: "平台清洗规则列表",
        name: "sizeAccessPlatformRuleFormCreate",
        parent: [
          {
            path: "/sizeAccess",
            name: "sizeAccess",
            title: "尺码管理",
          },
          {
            path: "/sizeAccess/platformRules",
            title: "平台清洗规则列表",
            name: "sizeAccessPlatformRules",
          }
        ],
        component: resolve => {
          require(["@/views/size/ruleForm.vue"], resolve);
        }
      },
      {
        path: "rule/platform/edit/:id",
        title: "平台清洗规则列表",
        name: "sizeAccessPlatformRuleFormEdit",
        parent: [
          {
            path: "/sizeAccess",
            name: "sizeAccess",
            title: "尺码管理",
          },
          {
            path: "/sizeAccess/platformRules",
            title: "平台清洗规则列表",
            name: "sizeAccessPlatformRules",
          }
        ],
        component: resolve => {
          require(["@/views/size/ruleForm.vue"], resolve);
        }
      },
      {
        path: "platformRules",
        title: "平台规则管理",
        name: "sizeAccessPlatformRules",
        component: resolve => {
          require(["@/views/size/platformRules.vue"], resolve);
        }
      },
      {
        path: "productRules",
        title: "指定商品清洗规则管理",
        name: "sizeAccessProductRules",
        component: resolve => {
          require(["@/views/size/productRules.vue"], resolve);
        }
      },
    ]
  },
]

export default customerRoutes
